import SideBar from "../sidebar/SideBar";
import Header from "../header/Header";
import { Link } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import { useState } from "react";
import { FaPlus } from "react-icons/fa6";
import LoadAddress from "./loadAddress";
import UnloadAddress from "./UnloadAddress";
import { Select } from "antd";
import DashboardLayout from "../layout";

function CreateShipment() {
  const obj = {
    ative: true,
    content: "Book Shipment",
  };

  const [inputSets, setInputSets] = useState(1);

  const handleAddSet = () => {
    setInputSets((prevSets) => prevSets + 1);
  };

  const { getRootProps, getInputProps, acceptedFiles } = useDropzone();

  return (
    <>
      <DashboardLayout>
        {/* <div className="hidden sm:block">
          <SideBar obj={obj} />
        </div> */}
        <div className="w-full border border-red">
          <Header title="Book Shipment" />
          <div className="p-2 sm:p-4 bg-cus-gray">
            <div className="mx-auto bg-white border rounded-md sm:p-4">
              <div>
                {/* Collection */}
                {/* Collection */}
                {/* Collection */}
                <h2 className="mx-[30px] font-bold text-xl mt-4">
                  Customer Information{" "}
                </h2>
                <div className=" mx-[30px] grid md:grid-cols-2 grid-cols-1 gap-3">
                  <div className="flex flex-col gap-1 py-2">
                    <label
                      className="w-full text-sm font-normal "
                      htmlFor="name"
                    >
                      Name
                    </label>
                    <input
                      type="text"
                      placeholder="Name"
                      className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                      id="name"
                    />
                  </div>
                  <div className="flex flex-col gap-1 py-2">
                    <label
                      className="w-full text-sm font-normal "
                      htmlFor="companyname"
                    >
                      Email Address
                    </label>
                    <input
                      type="text"
                      placeholder="Email Address"
                      className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                      id="companyname"
                    />
                  </div>
                  <div className="flex flex-col gap-1 py-2">
                    <label
                      className="w-full text-sm font-normal "
                      htmlFor="addressone"
                    >
                      Postal Code
                    </label>
                    <input
                      type="number"
                      placeholder="Postal Code"
                      className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                      id="addressone"
                    />
                  </div>
                  <div className="flex flex-col gap-1 py-2">
                    <label
                      className="w-full text-sm font-normal "
                      htmlFor="addresstwo"
                    >
                      House No
                    </label>
                    <input
                      type="text"
                      placeholder="House No"
                      className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                      id="addresstwo"
                    />
                  </div>
                  <div className="flex flex-col gap-1 py-2">
                    <label
                      className="w-full text-sm font-normal "
                      htmlFor="country"
                    >
                      Place
                    </label>
                    <input
                      type="text"
                      className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                      id="country"
                    />
                  </div>
                  <div className="flex flex-col gap-1 py-2">
                    <label
                      className="w-full text-sm font-normal"
                      htmlFor="country"
                    >
                      Country
                    </label>
                    <select
                      className="w-full h-8 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                      id="country"
                    >
                      <option value="option1">Option 1</option>
                      <option value="option2">Option 2</option>
                      <option value="option3">Option 3</option>
                    </select>
                  </div>
                </div>

                <div className="mx-[30px]">
                  <div className="flex flex-col gap-1 py-2 ">
                    <label
                      className="w-full text-sm font-normal "
                      htmlFor="name"
                    >
                      Mode of Transport
                    </label>
                    <Select
                      options={[
                        { label: "By Air", value: "By Air" },
                        { label: "By Road", value: "By Road" },
                        { label: "By Sea", value: "By Sea" },
                      ]}
                      showSearch
                      className="w-full h-8 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                    ></Select>
                  </div>
                </div>

                <div className="mx-[30px] grid  grid-cols-1 md:grid-cols-2 gap-3">
                  <div className="flex flex-col gap-1 py-2">
                    <label
                      className="w-full text-sm font-normal "
                      htmlFor="country"
                    >
                      Cargo Value
                    </label>
                    <input
                      type="text"
                      className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                      id="country"
                    />
                  </div>
                  <div className="flex flex-col gap-1 py-2">
                    <label
                      className="w-full text-sm font-normal "
                      htmlFor="country"
                    >
                      CIF Value
                    </label>
                    <input
                      type="text"
                      className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                      id="country"
                    />
                  </div>
                </div>

                <h2 className="mx-[30px] font-bold text-xl mt-4">Goods</h2>

                <div className="mx-[30px] grid  grid-cols-1 md:grid-cols-2 gap-3">
                  <div className="flex flex-col gap-1 py-2">
                    <label
                      className="w-full text-sm font-normal "
                      htmlFor="country"
                    >
                      Pcs Package<span className="text-[red] ">*</span>
                    </label>
                    <input
                      type="text"
                      className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                      id="country"
                    />
                  </div>
                  <div className="flex flex-col gap-1 py-2">
                    <label
                      className="w-full text-sm font-normal "
                      htmlFor="country"
                    >
                      Weight<span className="text-[red] ">*</span>
                    </label>
                    <input
                      type="number"
                      className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                      id="country"
                    />
                  </div>
                </div>

                <div className="mx-[30px] grid md:grid-cols-3 grid-cols-1 gap-3">
                  <div className="flex flex-col gap-1 py-2">
                    <label
                      className="w-full text-sm font-normal "
                      htmlFor="country"
                    >
                      Length<span className="text-[red] ">*</span>
                    </label>
                    <input
                      type="text"
                      className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                      id="country"
                    />
                  </div>
                  <div className="flex flex-col gap-1 py-2">
                    <label
                      className="w-full text-sm font-normal "
                      htmlFor="country"
                    >
                      Weight<span className="text-[red] ">*</span>
                    </label>
                    <input
                      type="number"
                      className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                      id="country"
                    />
                  </div>
                  <div className="flex flex-col gap-1 py-2">
                    <label
                      className="w-full text-sm font-normal "
                      htmlFor="country"
                    >
                      Height<span className="text-[red] ">*</span>
                    </label>
                    <input
                      type="number"
                      className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                      id="country"
                    />
                  </div>
                </div>

                <div className="mx-[30px] flex flex-col gap-1 py-2">
                  <label
                    className="w-full text-sm font-normal "
                    htmlFor="country"
                  >
                    Description<span className="text-[red] ">*</span>
                  </label>
                  <textarea
                    placeholder="Description"
                    className="w-full h-[150px] p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                    id="country"
                  />
                </div>

                <h2 className="mx-[30px] font-bold text-xl mt-4">Services</h2>

                {[...Array(inputSets)].map((_, index) => (
                  <div className="flex flex-col lg:flex-row gap-3 mx-[30px] ">
                    <div className=" w-full lg:w-[20%] flex flex-col gap-1 py-2">
                      <label
                        className="w-full text-sm font-normal "
                        htmlFor="country"
                      >
                        Number
                      </label>
                      <input
                        type="number"
                        className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                        id="country"
                      />
                    </div>
                    <div className=" w-full lg:w-[60%] flex flex-col gap-1 py-2">
                      <label
                        className="w-full text-sm font-normal "
                        htmlFor="country"
                      >
                        Description
                      </label>
                      <input
                        type="number"
                        className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                        id="country"
                      />
                    </div>
                    <div className=" w-full lg:w-[10%] flex flex-col gap-1 py-2">
                      <label
                        className="w-full text-sm font-normal "
                        htmlFor="country"
                      >
                        Price
                      </label>
                      <input
                        type="number"
                        className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                        id="country"
                      />
                    </div>
                    <div className=" w-full lg:w-[10%] flex flex-col gap-1 py-2">
                      <label
                        className="w-full text-[gray] text-sm font-normal "
                        htmlFor="country"
                      >
                        excl.VAT
                      </label>
                      <input
                        type="number"
                        className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                        id="country"
                      />
                    </div>
                    <div>
                      <h1 className="mt-2">Total</h1>

                      <p className="mt-3 text-[gray] ">&300.0</p>
                    </div>
                  </div>
                ))}

                <div className="mx-[30px] flex flex-col lg:flex-row gap-2 ">
                  <div className="w-full lg:w-[60%] bg-[#FBFCFF] p-4 rounded-lg  border border-cus-blue ">
                    <h1 className=" text-[16px] font-bold ">
                      Transport Warehouse - Hoofdrop
                    </h1>

                    <p className="text-[gray] ">
                      Selling Price: $0.00 excl VAT
                    </p>
                  </div>

                  <div className="w-full lg:w-[40%] bg-[#FBFCFF] p-4 border rounded-lg border-cus-blue">
                    <div className="flex justify-between">
                      <div>
                        <p className="text-[14px]">Total Excl.VAT</p>
                      </div>

                      <div className="">
                        <p className="text-[14px] font-extrabold ">$44,88.00</p>
                      </div>
                    </div>

                    <div className="flex justify-between mt-1 ">
                      <div>
                        <p className="text-[14px]">Total VAT Height</p>
                      </div>

                      <div className="">
                        <p className="text-[14px] font-extrabold ">$44,88.00</p>
                      </div>
                    </div>

                    <div className="flex justify-between mt-4 border-t border-cus-blue ">
                      <div className="mt-2">
                        <p className="text-[14px]">To Pay</p>
                      </div>

                      <div className="mt-2">
                        <p className="text-[14px] font-extrabold ">$44,88.00</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mx-[30px] mt-3 " onClick={handleAddSet}>
                  <FaPlus className="text-[20px] text-[#03336E] " />
                </div>

                <div className="mx-[30px] flex flex-col gap-3 sm:flex-row justify-between mt-4 ">
                  <button className="px-12 py-2 bg-[#03336E] rounded-lg text-[#fff] ">
                    To Proceded
                  </button>
                </div>

                <h2 className="mx-[30px] font-bold  text-xl mt-8">
                  Order Details
                </h2>

                <div className="flex flex-col lg:flex-row gap-3 mx-[30px] ">
                  <div className="flex flex-col w-full gap-1 py-2 ">
                    <label
                      className="w-full text-sm font-normal "
                      htmlFor="country"
                    >
                      Pick Up Date
                    </label>
                    <input
                      type="date"
                      className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                      id="country"
                    />
                  </div>

                  <div className="flex flex-col w-full gap-1 py-2 ">
                    <label
                      className="w-full text-sm font-normal "
                      htmlFor="country"
                    >
                      Delivery Date
                    </label>
                    <input
                      type="date"
                      className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                      id="country"
                    />
                  </div>
                </div>

                <div className="flex flex-col lg:flex-row gap-3 mx-[30px] ">
                  <div className="flex flex-col w-full gap-1 py-2 ">
                    <label
                      className="w-full text-sm font-normal "
                      htmlFor="country"
                    >
                      Customer
                    </label>

                    <select className="w-full h-8 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue">
                      <option>NTT Date</option>
                      <option>NTT Date</option>
                      <option>NTT Date</option>
                    </select>
                  </div>

                  <div className="flex flex-col w-full gap-1 py-2 ">
                    <label
                      className="w-full text-sm font-normal "
                      htmlFor="country"
                    >
                      Products
                    </label>

                    <select className="w-full h-8 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue">
                      <option>IQR</option>
                      <option>IQR</option>
                      <option>IQR</option>
                    </select>
                  </div>
                </div>

                <div className="flex flex-col lg:flex-row gap-3 mx-[30px] ">
                  <div className="flex flex-col w-full gap-1 py-2 ">
                    <label
                      className="w-full text-sm font-normal "
                      htmlFor="country"
                    >
                      Career
                    </label>

                    <select className="w-full h-8 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue">
                      <option>Select</option>
                      <option>Select</option>
                      <option>Select</option>
                    </select>
                  </div>

                  <div className="flex flex-col w-full gap-1 py-2 ">
                    <label
                      className="w-full text-sm font-normal "
                      htmlFor="country"
                    >
                      Order Substatus
                    </label>

                    <select className="w-full h-8 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue">
                      <option>In Transit</option>
                      <option>In Transit</option>
                      <option>In Transit</option>
                    </select>
                  </div>
                </div>

                <h2 className="mx-[30px] font-bold text-xl mt-4">Edit Order</h2>

                <h2 className="mx-[30px] font-bold text-xl mt-4">
                  Load Address
                </h2>

                <div className="mx-[30px] mt-4 ">
                  <LoadAddress />
                </div>

                <h2 className="mx-[30px] font-bold text-xl mt-4">
                  Unload Address
                </h2>
                <div className="mx-[30px] mt-4 ">
                  <UnloadAddress />
                </div>

                <div className="flex flex-col gap-1 mx-[30px] mt-4">
                  <label>Delivery Note</label>

                  <textarea className="border border-[#B3C5DF] h-[300px] rounded-lg  focus:outline-none p-2 " />
                </div>

                <div className="flex justify-end mt-4 mx-[30px]  ">
                  <button className="px-10 py-2 border rounded-lg border-[#9C9C9C] ">
                    Generated pdf
                  </button>
                </div>

                <div
                  {...getRootProps()}
                  className="mx-[30px]  cursor-pointer active:opacity-70 font-semibold flex justify-center items-center border-2 h-[92px] mt-8 border-dashed  border-[#053F924A]"
                >
                  <input {...getInputProps()} />
                  <p className="text-[10px] md:text-[15px] text-black">
                    {acceptedFiles.length > 0
                      ? `File: ${acceptedFiles[0].name}`
                      : "Drag file here to upload"}
                  </p>
                </div>

                <div
                  {...getRootProps()}
                  className="mx-[30px]  cursor-pointer active:opacity-70 font-semibold flex justify-center items-center border-2 h-[92px] mt-8 border-dashed  border-[#053F924A]"
                >
                  <input {...getInputProps()} />
                  <p className="text-[10px] md:text-[15px] text-black">
                    {acceptedFiles.length > 0
                      ? `File: ${acceptedFiles[0].name}`
                      : "Drag file here to upload"}
                  </p>
                </div>

                <button
                  className="mx-[30px] px-8 py-2 text-[#fff] rounded-lg mt-4 "
                  style={{ background: "#053f92" }}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </DashboardLayout>
    </>
  );
}

export default CreateShipment;
